import { log } from "./log";
import { client } from "./supabase"; // Import the actual client from your supabase file

export const login = async ({ email, pais, senderEmail, isLocalhost }) => {
  try {
    const { data: result, error } = await client.functions.invoke("hyper-function", {
      body: { email, pais, senderEmail, isLocalhost },
    });

    log.debug("login resultado:", result);

    if (error) {
      log.error("login", error);
      return { success: false, error: "unexpected" };
    }

    return result; // {success: true} or {success: false, error: 'invalid_email'}
  } catch (error) {
    log.error("login", error);
    return { success: false, error: "unexpected" };
  }
};
